import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../../../Common';
import Dialog from '../../../Dialog';
import LocationSelector from '../../../LocationSelector';
import LoginHeader from '../../../Login_header';
import Menu from '../../../Menu';
import * as Picklist from '../../../Picklist';

const Rep_outstanding_cmrp_ageing = () => {

  const navigate = useNavigate();
  const sid = sessionStorage.getItem('sessionId');
  const branchDisable = sessionStorage.getItem('branchDisable');
  const [onceRun, setOnceRun] = useState(false);
  const [userRight, setUserRight] = useState([]);
  const [isMsgBox, setMsgBox] = useState(false);
  const [msgText, setMsgText] = useState('');

  const [tillDate, setTillDate] = useState(new Date());
  const [GenerateType, setGenerateType] = useState("D");

  const [locationCode, setLocationCode] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [radioType, setRadioType] = useState("O");
  const [cmrType, setCmrType] = useState("P");
  const [scr, setScr] = useState("");
  const [filterLedgerType, setFilterLedgerType] = useState("A");
  const [ledgerValue, setLedgerValue] = useState(null);
  const [grpCode, setGrpCode] = useState('0');
  const [accCode, setAccCode] = useState('0');

  useEffect(() => {
    if (onceRun) {
      return;
    } else {
      Common.callApi(Common.apiRight, [sid, 'all', 'REP_FIN_OUTSTANDING_CMRP_AGEING'], function (result) {
        let resp = JSON.parse(result);
        if (resp.query === "1") {
          setUserRight(resp);
        } else {
          navigate('/');
        }
      });
      setOnceRun(true);
    }
  }, [onceRun, sid, navigate]);

  const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
    setLocationCode(newLocationCode);
    setSelectedItems(newSelectedItems);
    setRadioType(newRadioType);
  }

  const handleGenerate = () => {
    $(".loader").show();
    var msg = [], i = 0;
    if ((radioType === 'O' && locationCode === '0') || (radioType == 'S' && selectedItems.length === 0)) {
      msg[i++] = ((radioType == 'O' && locationCode == '0') ? "Please select location." : '');
      msg[i++] = ((radioType == 'S' && selectedItems.length === 0) ? "Please select atleast one location." : '');
      $(".loader").hide();
      setMsgText(Common.buildMessageFromArray(msg));
      setMsgBox(true);
    } else {
      const obj = {
        cmrType: cmrType,
        tillDate: Common.dateYMD(tillDate),
        type: GenerateType,
        radioTypeLocation: radioType,
        location: locationCode,
        multipleLocation: selectedItems,
        tillDateDMY: Common.dateDMY(tillDate),
      };
      //   if (GenerateType === 'D') {
      Common.callDownloadApiPost1(Common.apirepcmrpageing, "post", [sid, "ageingDownloadReport", JSON.stringify(obj)], result => {
        $(".loader").hide();
        setMsgText(Common.buildMessageFromArray([result]));
        setMsgBox(true);
      });
      //   } else {
      //     Common.callApi(Common.apirepoutstandingcmrp, [sid, "ageingDownloadReport", JSON.stringify(obj)], result => {
      //       var newWindow = window.open();
      //       newWindow.document.write(result);
      //       $(".loader").hide();
      //     });

      //   }
    }
  }
  const handleLedgerValue = (value) => {
    setLedgerValue(value);
    const account = value.id.split('^');
    setGrpCode(account[1]);
    setAccCode(account[2]);
  }

  return (
    <>
      <LoginHeader />
      <Menu />
      <Container fluid>
        <Row>
          <Col>
            <h3>Outstanding CMRP Ageing</h3>
          </Col>
        </Row>
        <Row>&nbsp;</Row>

        <Row>
          <Col className='col-md-3 col-6'>
            <Form.Group>
              <Form.Label>CMR Type<span className="text-danger">*</span></Form.Label>
              <Form.Select value={cmrType} onChange={e => setCmrType(e.target.value)}
                required>
                <option value="P">Payable</option>
                <option value="R">Recievable</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        {/* <Row>
          <Col className='col-md-3 col-6'>
            <Form.Group>
              <Form.Label>Ledger Type<span className="text-danger">*</span></Form.Label>
              <Form.Select value={filterLedgerType} onChange={e => setFilterLedgerType(e.target.value)}
                required>
                <option value="A">All</option>
                <option value="O">One</option>
              </Form.Select>
            </Form.Group>
          </Col>
          {filterLedgerType === 'O' ?
            <Col className='col-md-3 col-6'>
              <Form.Group>
                <Form.Label>Ledger<span className="text-danger">*</span></Form.Label>
                <AsyncSelect
                  cacheOptions={false}
                  defaultOptions={false}
                  value={ledgerValue}
                  getOptionLabel={e => e.label + ' '}
                  getOptionValue={e => e.id}
                  loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, locationCode)}
                  onInputChange={Picklist.handleInputChange}
                  onChange={handleLedgerValue}
                >
                </AsyncSelect>
              </Form.Group>
            </Col> : null
          }
        </Row> */}
        <Row>
          <Col className='col-md-3 col-6'>
            <Form.Group>
              <Form.Label> Till Date<span className="colorThemeRed">*</span></Form.Label><br />
              <DatePicker className="form-control"
                selected={tillDate}
                onChange={(date) => setTillDate(date)}
                dateFormat="dd/MM/yyyy"
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
                dropdownMode="select"
                peekNextMonth
                customInput={
                  <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                }
              />
            </Form.Group>
          </Col>
          <Col className='col-md-3 col-6'>
            <Form.Group>
              <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
              <Form.Select value={GenerateType} onChange={e => setGenerateType(e.target.value)}
                required>
                {/* <option value="V">View</option> */}
                <option value="D">Download</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
        <Row>&nbsp;</Row>
        <Row>
          <Col className='col-md-6 col-6'>
            <Form.Label>Location Filter</Form.Label><br />
            <LocationSelector onDataFromChild={handleDataFromChild} />
          </Col>
        </Row>
        <Row>&nbsp;</Row>
        <Row>
          <Col>
            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
          </Col>
        </Row>
        <Row>&nbsp;</Row>
      </Container>
      <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
        {msgText}
      </Dialog>
      <Row>&nbsp;</Row>
      <Row>&nbsp;</Row>
      <Row>&nbsp;</Row>
    </>
  )
}

export default Rep_outstanding_cmrp_ageing;
